"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountTypeOptions = exports.DiscountTypes = void 0;
exports.DiscountTypes = ['amount', 'percent'];
exports.DiscountTypeOptions = { amount: 'Amount off', percent: 'Percent off' };
//# sourceMappingURL=Coupon.js.map